/* eslint-disable camelcase */

export default class ClinicalSearchBox {
  constructor({
    gender, overall_status, age, study_type, localisation, search,
  } = {}) {
    this.gender = gender || 'tous';
    this.status = overall_status || 'tous';
    this.age = age;
    this.category = study_type;
    this.localisation = localisation;
    this.freeSearch = search;
  }

  static convertToFrontValues(DrupalParams) {
    const mapping = {
      gender: {
        male: 'homme',
        female: 'femme',
      },
      overall_status: {
        'Not yet recruiting': 'a-venir',
        Recruiting: 'en-cours',
      },
    };
    const response = { ...DrupalParams };
    // Remove slugify formatting
    Object.keys(response).forEach((key) => {
      if (typeof response[key] === 'string') {
        response[key] = response[key].replaceAll('-', ' ');
      }
    });
    // Map Drupal values to Front values
    Object.keys(mapping).forEach((key) => {
      if (response[key]) {
        response[key] = mapping[key][response[key]];
      }
    });
    return response;
  }
}
